import { SpecialAction } from '../SpecialAction';

export class SpecialRevive extends SpecialAction {
    id = '*revive';
}
